import React from 'react';
import { ArrowRight, Play } from 'lucide-react';
import { socialLinks } from '../data/mockData';

const HeroSection = () => {
  const scrollToProducts = () => {
    const element = document.getElementById('produtos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1513258496099-48168024aec0?w=1920&q=80" 
          alt="Estudante concentrado"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-950/90 to-blue-900/80"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-orange-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>

      {/* Content */}
      <div className="container mx-auto px-4 z-10 pt-24 pb-16">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Text Content */}
          <div className="text-white space-y-6">
            <div className="inline-block">
              <span className="bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold uppercase tracking-wide">
                Método Comprovado
              </span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              Domine o Direito em minutos.{' '}
              <span className="text-orange-400">Passe em concursos</span> mais rápido.
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-200">
              Flashcards inteligentes para acelerar sua aprovação
            </p>

            <ul className="space-y-3 text-lg">
              <li className="flex items-center space-x-3">
                <span className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-sm">✓</span>
                <span>Revisão ativa e eficiente</span>
              </li>
              <li className="flex items-center space-x-3">
                <span className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-sm">✓</span>
                <span>Conteúdo atualizado e completo</span>
              </li>
              <li className="flex items-center space-x-3">
                <span className="flex-shrink-0 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-sm">✓</span>
                <span>Metodologia comprovada</span>
              </li>
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button 
                onClick={scrollToProducts}
                className="group bg-orange-500 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-orange-600 transition-all duration-300 transform hover:scale-105 hover:shadow-xl flex items-center justify-center space-x-2"
              >
                <span>Começar Agora</span>
                <ArrowRight className="group-hover:translate-x-1 transition-transform" size={20} />
              </button>
              
              <a 
                href={socialLinks.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="group bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white/20 transition-all duration-300 border-2 border-white/30 flex items-center justify-center space-x-2"
              >
                <Play size={20} />
                <span>Assistir Aulas Gratuitas</span>
              </a>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4 pt-8 border-t border-white/20">
              <div>
                <div className="text-3xl font-bold text-orange-400">1000+</div>
                <div className="text-sm text-gray-300">Alunos Aprovados</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-400">8</div>
                <div className="text-sm text-gray-300">Disciplinas</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-orange-400">50%</div>
                <div className="text-sm text-gray-300">de Desconto</div>
              </div>
            </div>
          </div>

          {/* Image/Visual Element */}
          <div className="relative hidden md:block">
            <div className="relative z-10">
              <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20 shadow-2xl transform hover:scale-105 transition-transform duration-300">
                <div className="aspect-video bg-gradient-to-br from-orange-400 to-orange-600 rounded-lg mb-4 flex items-center justify-center overflow-hidden">
                  <img 
                    src="https://images.unsplash.com/photo-1501504905252-473c47e087f8?w=600&q=80" 
                    alt="Flashcards digitais"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="space-y-2">
                  <div className="h-4 bg-white/20 rounded w-3/4"></div>
                  <div className="h-4 bg-white/20 rounded w-1/2"></div>
                </div>
              </div>
            </div>
            {/* Floating Cards */}
            <div className="absolute -top-6 -right-6 bg-orange-500 text-white px-6 py-3 rounded-lg shadow-xl transform rotate-3 animate-pulse">
              <div className="font-bold text-2xl">50% OFF</div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/50 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
